<template>
  <div class="text-left">
    <div v-if="current_index === null">
      Nothing left to train
    </div>
    <div v-else>
      <b-card class="mb-4">
        <pre style='white-space: pre-wrap; text-align: left;'>{{this.item.script[current_index].text}}</pre>
        <br>
        <AudioRecorder :existing_audio="this.item.script[current_index].audio_url" :on_complete="on_complete" :key="current_index"/>
      </b-card>

      <LoadingButton @click="prev" class="mr-2" variant="secondary" :disabled="current_index === 0" size="sm">&lt; Prev</LoadingButton>
      <LoadingButton @click="next" class="mr-2" :loading="uploading" variant="secondary" :disabled="current_index === this.item.script.length-1" size="sm">Next &gt;</LoadingButton>
      <b-link>{{current_index + 1}} of {{this.item.script.length}}</b-link>

      <div v-if="current_index === this.item.script.length-1 && this.audio_data" class="mt-2">
        <LoadingButton :loading="uploading" @click="submit_training_data" variant="primary">Submit training data</LoadingButton>
      </div>

      <b-card class="mt-4 tips-card">
        <h4>Tips</h4>
        <ul>
          <li>Speak clearly, energetically, but not too quickly</li>
          <li>Minimise background noise</li>
          <li>Try not to make too many mistakes when recording the audio, but a few is fine</li>
          <li>Use the best microphone available, but a laptop microphone should be fine</li>
          <li>Try not to move around or change your distance from the microphone</li>
        </ul>
      </b-card>

      <!-- <div v-if="profile.role === 'admin'" class='mt-2'>
        <LoadingButton @click="combine_training_data">Combine</LoadingButton>
      </div> -->
    </div>
  </div>
</template>

<script>
import api from '@/lib/api.js'
import { db, storage } from '@/main.js'
import { required, minLength } from "vuelidate/lib/validators"
import AudioRecorder from "@/components/AudioRecorder.vue"

export default {
  components: {AudioRecorder},
  props: ['on_submit', 'item'],
  computed: {
    current_script() {
      if (!this.item || !this.item.script) {
        return null
      }

      let i = 0
      for (let script of this.item.script) {
        if (script.audio_url === null) {
          return i
        }
        i++
      }

      return null
    }
  },
  data() {
    return {
      collection: 'voice',
      current_index: null,
      uploading: false,
      audio_data: null
    }
  },
  watch: {
    item: {
      deep: true,
      handler: function() {
        if (this.current_index === null && this.item && this.item.script) {
          this.current_index = 0
          let i = 0
          for (let script of this.item.script) {
            if (script.audio_url === null) {
              this.current_index = i
              break
            }
            i++
          }
        }
      }
    }
  },
  methods: {
    async combine_training_data() {
      await api.combine_training_data(this.item.id)
    },
    async submit_training_data() {
      this.uploading = true
      let snap = await storage.ref().child(`voice/${this.item.id}/${db.collection('media').doc().id}.mp3`).put(this.audio_data, {contentType: 'audio/mp3'})
      let url = await snap.ref.getDownloadURL()
      this.item.script[this.current_index].audio_url = url

      let all_complete = true
      let i = 0
      for (let script of this.item.script) {
        if (script.audio_url === null) {
          this.$swal({title: 'No file', text: `Please upload audio for script ${i+1}`, icon: 'warning'})
          this.uploading = false
          break
        }
        i++
      }

      await db.collection('voice').doc(this.item.id).update({updated: new Date(), script: this.item.script, status: 'pending'})

      if (this.on_submit) {
        return this.on_submit()
      }

      this.uploading = false
      this.$router.push({name: 'voice', params: {id: this.item.id}})
    },
    async on_complete(data) {
      this.audio_data = data
    },
    async next() {
      if (this.item.script[this.current_index].audio_url) {
        // pass
      } else if (!this.audio_data) {
        this.$swal({title: 'No audio data', text: "Please upload audio data before continuing", icon: 'warning'})
        return
      } else {
        this.uploading = true
        let snap = await storage.ref().child(`voice/${this.item.id}/${db.collection('media').doc().id}.mp3`).put(this.audio_data, {contentType: 'audio/mp3'})
        let url = await snap.ref.getDownloadURL()
        this.item.script[this.current_index].audio_url = url
        this.audio_data = null

        // TODO upload the script?
        await db.collection('voice').doc(this.item.id).update({updated: new Date(), script: this.item.script})

        this.uploading = false
      }

      if (this.current_index < this.item.script.length-1) {
        this.current_index++
      }
    },
    prev() {
      if (this.audio_data) {
        this.$swal({title: 'Audio data not uploaded', text: "Please go forward to upload audio data before continuing", icon: 'warning'})
        return
      }

      if (this.current_index > 0) {
        this.current_index--
      }
    }
  }
}
</script>

<style>

</style>
